import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IDialogData {
  title: string;
  content: string;
  isActive: boolean;
  isLoading: boolean;
}

@Component({
  selector: 'app-basic-dialog',
  standalone: false,
  templateUrl: './basic-dialog.component.html',
  styleUrl: './basic-dialog.component.scss'
})
export class BasicDialogComponent {

  private readonly dialog = inject(MatDialog);
  protected readonly dialogRef = inject(MatDialogRef<BasicDialogComponent>);
  protected readonly data = inject<IDialogData>(MAT_DIALOG_DATA);

  protected onYesClick() {
    this.dialogRef.close(true);
  }

}
